var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMethodoContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 49 32",
    id: "svg10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, "Methodo_Contact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TaxAnalytics_Desk_FEC_01",
    transform: "translate(-170.000000, -1942.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MISSION",
    transform: "translate(158.000000, 1698.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Methodo_Contact",
    transform: "translate(13.000000, 245.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    d: "m 32.5427,6.6705 c 7.985,0 14.458,4.757 14.458,10.626 0,4.019 -3.037,7.514 -7.515,9.32 1.636,1.718 3.421,2.895 3.421,2.895 0,0 -4.277,0.538 -7.489,-1.8 -0.929,0.137 -1.891,0.211 -2.875,0.211 -7.985,0 -14.458,-4.757 -14.458,-10.626 0,-5.869 6.473,-10.626 14.458,-10.626 z M 29.343,2.461 C 26.318,0.91 22.639,0 18.671,0 8.359,0 0,6.143 0,13.722 c 0,5.189 3.921,9.704 9.703,12.035 -2.111,2.219 -4.417,3.739 -4.417,3.739 0,0 5.523,0.695 9.672,-2.326 1.2,0.178 2.441,0.274 3.713,0.274"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethodoContact);
export default __webpack_public_path__ + "static/media/Methodo_Contact.be96c8a4529804a444c69115de5272e4.svg";
export { ForwardRef as ReactComponent };